import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { documentsKeys } from './documents.keys';
import { documentsQueryOptimisticAdd } from './documents.query.update';
import { getDocuments, uploadDocument, deleteDocument, downloadDocument, downloadDocumentAsMd, getContextDocuments, uploadContextDocument, deleteContextDocument, attachContextDocument } from './documents.api';
/* DOCUMENT QUERIES */
export const useDocumentsQuery = () => {
    return useQuery({
        queryKey: documentsKeys.all(),
        queryFn: () => getDocuments(),
        staleTime: 1000
    });
};
export const useUploadDocumentMutation = () => {
    return useMutation({
        mutationFn: uploadDocument,
        onSuccess: (doc) => {
            documentsQueryOptimisticAdd(doc);
        }
    });
};
export const useDocumentDownloadMutation = () => {
    return useMutation({
        mutationFn: downloadDocument
    });
};
export const useDocumentDownloadAsMdMutation = () => {
    return useMutation({
        mutationFn: downloadDocumentAsMd
    });
};
export const useDeleteDocumentMutation = () => {
    return useMutation({
        mutationFn: deleteDocument,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: documentsKeys.all() }).then();
        }
    });
};
/* CONTEXT DOCUMENT QUERIES */
export const useContextDocumentsQuery = () => {
    return useQuery({
        queryKey: documentsKeys.contextAll(),
        queryFn: () => getContextDocuments()
    });
};
export const useUploadContextDocumentMutation = () => {
    return useMutation({
        mutationFn: uploadContextDocument,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: documentsKeys.contextAll() }).then();
        }
    });
};
export const useAttachContextDocumentMutation = () => {
    return useMutation({
        mutationFn: attachContextDocument,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: documentsKeys.contextAll() }).then();
        }
    });
};
export const useDeleteContextDocumentMutation = () => {
    return useMutation({
        mutationFn: deleteContextDocument,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: documentsKeys.contextAll() }).then();
        }
    });
};
//# sourceMappingURL=documents.query.js.map